var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.47 2.3c.53.27.95.7 1.22 1.23.31.6.31 1.22.31 2.35v6.84c0 1.13 0 1.75-.31 2.35-.27.53-.69.95-1.22 1.22-.51.26-1.04.3-1.87.3v-5.31c0-1.3 0-2.23-.53-3.26a4.8 4.8 0 0 0-2.1-2.1c-1.02-.52-1.96-.52-3.25-.52H7.41c0-.84.04-1.36.29-1.87.27-.53.69-.96 1.22-1.23.6-.3 1.22-.3 2.36-.3h6.84c1.12 0 1.75 0 2.35.3M16.6 18.12v-6.84c0-1.13 0-1.75-.3-2.35-.26-.54-.69-.96-1.22-1.23-.6-.31-1.22-.31-2.35-.31H5.89c-1.13 0-1.75 0-2.35.31-.53.27-.95.69-1.22 1.22-.31.6-.31 1.22-.31 2.35v6.84c0 1.13 0 1.75.3 2.35.27.54.69.96 1.22 1.23.6.31 1.22.31 2.35.31h6.84c1.13 0 1.75 0 2.35-.31.53-.27.95-.69 1.22-1.22.31-.6.31-1.22.31-2.35",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;